export default "__VITE_ASSET__74b8923b__"